<div class="w-full flex flex-col gap-16 md:gap-28">
  <!-- Sección de la cabecera. -->
  <section class="mt-16 md:mt-28 flex flex-col gap-4">
    <h1 class="text-4xl font-medium md:text-5xl">Registros</h1>
    <p class="text-lg md:text-xl">
      Consulte el historial de accesos de los empleados.
    </p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="flex flex-col gap-10">
    <div
      class="flex flex-col md:flex-row md:justify-between md:flex-wrap gap-5"
    >
      <div class="flex flex-col md:flex-row gap-5">
        <button
          mat-raised-button
          aria-hidden="false"
          aria-label="Actualizar"
          (click)="reload()"
          [disabled]="loading"
        >
          <mat-icon>refresh</mat-icon>
          <span>Actualizar</span>
        </button>
        <button
          mat-flat-button
          aria-hidden="false"
          aria-label="Eliminar todo"
          (click)="deleteAll()"
        >
          <mat-icon>delete</mat-icon>
          <span>Eliminar todo</span>
        </button>
      </div>
      <div class="flex flex-col md:flex-row gap-5">
        @if(showFilters) {
        <button
          mat-raised-button
          aria-label="Esconder filtros"
          (click)="showFilters = !showFilters"
        >
          <mat-icon> filter_alt_off </mat-icon>
          <span class="text-nowrap">Esconder filtros</span>
        </button>
        } @else {
        <button
          mat-raised-button
          aria-label="Mostrar filtros"
          (click)="showFilters = !showFilters"
        >
          <mat-icon> filter_alt </mat-icon>
          <span class="text-nowrap">Mostrar filtros</span>
        </button>
        }
      </div>
    </div>

    @if (showFilters) {
    <form
      class="flex flex-col md:flex-row md:items-center md:flex-wrap gap-5"
      [formGroup]="form"
      (ngSubmit)="filter()"
    >
      <mat-form-field class="w-full md:w-[180px]">
        <mat-label>Empleado</mat-label>
        <input matInput name="employeeName" formControlName="employeeName" />
      </mat-form-field>
      <mat-form-field class="w-full md:w-[250px]">
        <mat-label>IP</mat-label>
        <input matInput name="ipAddress" formControlName="ipAddress" />
      </mat-form-field>
      <mat-form-field class="w-full md:w-[200px]">
        <mat-label>Fecha de inicio</mat-label>
        <input
          matInput
          [matDatepicker]="filterPicker1"
          name="startDate"
          formControlName="startDate"
          placeholder="dd/mm/aaaa"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="filterPicker1"
        ></mat-datepicker-toggle>
        <mat-datepicker #filterPicker1></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="w-full md:w-[200px]">
        <mat-label>Fecha de final</mat-label>
        <input
          matInput
          [matDatepicker]="filterPicker2"
          name="endDate"
          formControlName="endDate"
          placeholder="dd/mm/aaaa"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="filterPicker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #filterPicker2></mat-datepicker>
      </mat-form-field>
      <button mat-flat-button aria-hidden="false" aria-label="Filtrar">
        <span class="text-nowrap">Filtrar</span>
      </button>
    </form>
    }

    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="tableData"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="createdAt">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por fecha de creación"
          >
            Fecha
          </th>
          <td mat-cell *matCellDef="let log" class="text-nowrap">
            {{ log.createdAt | date : "d MMM, y, H:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="employee.displayName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por empleado"
          >
            Empleado
          </th>
          <td mat-cell *matCellDef="let log">
            {{ log.employee.displayName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="ipAddress">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por IP"
          >
            IP
          </th>
          <td mat-cell *matCellDef="let log">
            {{ log.ipAddress }}
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por descripción"
          >
            Descripción
          </th>
          <td mat-cell *matCellDef="let log">
            {{ log.description }}
          </td>
        </ng-container>
        <ng-container matColumnDef="userAgent">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por user agent"
          >
            User Agent
          </th>
          <td mat-cell *matCellDef="let log">
            {{ log.userAgent }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td colspan="9" class="mat-cell py-5 text-gray-500 text-center">
            No hay registros
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20, 50]"
      showFirstLastButtons
      aria-label="Selecciona la página"
    >
    </mat-paginator>
  </section>
</div>
